export function formatValidationType(rawType) {
  const t = typeof rawType === "string" ? rawType.trim() : "";
  if (!t) return "Generic";

  const upper = t.toUpperCase();
  if (upper === "GENERIC") return "Generic";
  if (upper === "COVID_19" || upper === "COVID-19") return "COVID-19";
  if (upper === "INFLUENZA") return "Influenza";
  if (upper === "PNEUMO") return "Pneumo";

  return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
}

